module.exports = __webpack_public_path__ + "static/media/i10.aa751f1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i10.svg
// module id = 204
// module chunks = 8